// Calls to the inv-api Edge Function (online invoices, Stripe, email). Everything here needs a Supabase project;
// without one the app keeps working fully offline and these features simply don't appear.
import { supabase, syncConfigured } from "./supabaseClient.js";

// Separate function so address lookups never touch invoice code.
async function callRoute(body) {
  if (typeof __PREVIEW__ !== "undefined" && __PREVIEW__) {
    // Preview build only: there is no network here, so return a clearly-labelled sample distance.
    const s = (body.from + "|" + body.to).split("").reduce((h, ch) => (h * 31 + ch.charCodeAt(0)) >>> 0, 7);
    await new Promise((res) => setTimeout(res, 600));
    return { meters: 3000 + (s % 38000), fromLabel: "Preview demo", toLabel: "sample distance, not a real route", provider: "demo" };
  }
  if (!syncConfigured) throw new Error("Address lookup needs an online account. Open Settings, then Account & sync, and sign in. You can still type the distance yourself.");
  const { data, error } = await supabase.functions.invoke("route-distance", { body });
  if (error) {
    let msg = error.message || "Lookup failed";
    try { const j = await error.context?.json?.(); if (j?.error || j?.message) msg = j.error || j.message; } catch (e) { /* keep default */ }
    if (/not found|404|failed to send|fetch/i.test(msg) && !/find|route|limit|sign in/i.test(msg)) msg = "Address lookup isn't set up on the server yet (the route-distance function). You can still type the distance yourself.";
    throw new Error(msg);
  }
  if (data?.error) throw new Error(data.error);
  return data;
}

async function call(body) {
  if (!syncConfigured) throw new Error("This needs a synced account.");
  const { data, error } = await supabase.functions.invoke("inv-api", { body });
  if (error) {
    let msg = error.message || "Request failed";
    try { const j = await error.context?.json?.(); if (j?.error) msg = j.error; } catch (e) { /* keep default */ }
    throw new Error(msg);
  }
  if (data?.error) throw new Error(data.error);
  return data;
}

export const remote = {
  routeDistance: (p) => callRoute(p),
  available: () => syncConfigured,
  config: () => call({ action: "config" }),
  sync: () => call({ action: "sync" }),
  connectStatus: () => call({ action: "connect", mode: "status" }),
  connectOnboard: () => call({ action: "connect", mode: "onboard" }),
  publish: (p) => call({ action: "publish", ...p }),
  unpublish: (invoiceId) => call({ action: "unpublish", invoiceId }),
  send: (p) => call({ action: "send", ...p }),
  // public (no login) — used by the client-facing invoice page
  publicInvoice: (token, track = true) => call({ action: "public", token, track }),
  payUrl: (token) => call({ action: "pay", token }),
};

export const invoiceLink = (token) => `${window.location.origin}${window.location.pathname}#/inv/${token}`;
